module.exports = [
  {
    title: 'Наименование',
    key: 'name'
  },
  {
    title: 'Код',
    key: 'code'
  },
  {
    title: 'Активен',
    key: 'is_active'
  }
]
